import React, { useEffect } from 'react';
import moment from 'moment';
import history from 'dashboard/history';
import SashiDo from 'lib/SashiDo';
import { useSetState } from 'lib/helpers';


const Comp = ({ currentApp, children }) => {
  const [state, setState] = useSetState({
    showChildren: false
  });

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    init();
  }, [currentApp]);


  const init = async () => {
    let showNotificationDate = window.localStorage.getItem('NotificationDateRedis');

    if (!showNotificationDate) {
      showNotificationDate = moment(new Date()).add(-1, 'days');
    }

    const showNotification = moment().isAfter(showNotificationDate);

    if (!showNotification) {
      return null;
    }


    const { pathname } = history.getCurrentLocation();

    if (
      pathname.includes('live_queries') ||
      pathname.includes('browser')
    ) {
      return null
    }

    const { id: appId, params } = currentApp;
    const { settings } = params;
    const { liveQueriesClasses, liveQueriesRedisURL } = settings || {};

    try {
      const containerCurrentDeployment = await SashiDo.containerCurrentDeployment({ appId });
      const { min, auto } = containerCurrentDeployment.deployment.replicas;

      if (
        (liveQueriesClasses && liveQueriesClasses.length > 0) &&
        (auto || min && min > 1) &&
        (!liveQueriesRedisURL || liveQueriesRedisURL === "")
      ) {
        setState(state => {
          state.showChildren = true;
        })
      }

    } catch (e) {
      console.error(e);
    }
  }

  if (state.showChildren) {
    return children;
  }


  return null;
}

export default Comp;


// export const ShowWhenNeedRedis = (initialFields = {}) => {
//   const { liveQueriesClasses, highly_available, engine_scaling_config, liveQueriesRedisURL } = initialFields || {};

//   if (
//     liveQueriesClasses &&
//     liveQueriesClasses.length > 0 &&
//     highly_available &&
//     !use_redis
//   ) {
//     console.log('bla bla')
//   }

// };
